import { Divider } from '@mui/material';

import { Dialog } from '@components/dialog/Dialog';
import { NotesDialogContent, NotesDialogContentProps } from '@components/notesDialog/NotesDialogContent';

export interface NotesDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  dialogContentProps: NotesDialogContentProps;
}

export const NotesDialog = ({ open, onClose, title, dialogContentProps }: NotesDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      handleCloseDialog={onClose}
      maxWidth='lg'
      fullWidth
      size='fullWidth'
      allowFullscreen={true}
      title={title}
      sxProps={sxProps.dialog}
    >
      <Divider />
      <NotesDialogContent {...dialogContentProps} />
    </Dialog>
  );
};

// Consolidated style object to keep JSX clean
const sxProps = {
  dialog: {
    dialogContent: {
      height: '100%',
      overflow: 'hidden',
      marginBottom: 0,
      flexDirection: 'column',
      display: 'flex',
      flex: 1,
      minHeight: 0,
    },
    paperSx: {
      overflow: 'hidden',
    },
  },
} as const;
